/* unplugin-vue-components disabled */import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=75efac29&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75efac29"]])

export default __exports__